export default "assets/images/icons/arrow-article-92386dd4.svg";